export const CollectionCreateIcon = () => {
  return (
    <svg
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.0007 1.83301L1.83398 6.41634L11.0007 10.9997L20.1673 6.41634L11.0007 1.83301Z'
        stroke='#1F1F24'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M1.83398 15.583L11.0007 20.1663L20.1673 15.583'
        stroke='#1F1F24'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M1.83398 11L11.0007 15.5833L20.1673 11'
        stroke='#1F1F24'
        stroke-width='1.63447'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
